import { useEffect } from 'react'
import { useAnalyticsView } from '@/features/amplitude'
import { Accordion, Image, Text } from '@/ui'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'
import { TypographyStyles } from '@/styles'
export const IntroPage = () => {
  const currentYear = new Date().getFullYear()
  const pageView = useAnalyticsView()

  useEffect(() => {
    pageView('statements splash')
  }, [pageView])

  const shouldEnableAutoReconCUBK2 = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.enableAutoreconCUBK2,
    false
  )

  return (
    <div className="flex flex-col lg:flex-row mt-4 gap-6">
      <div className="w-full lg:w-1/3">
        <Image
          src="https://heard-images.s3.amazonaws.com/assets/statement.svg"
          alt="Bank Statement"
          className="p-5 bg-moss-25"
        />
      </div>

      <div className="w-full lg:w-2/3 flex flex-col gap-8">
        <div className="space-y-2">
          <Text variant={TypographyStyles.H2}>
            Share your monthly bank statements
          </Text>
          {shouldEnableAutoReconCUBK2 ? (
            <Text>
              Next, we&apos;ll ask you to share monthly bank statements for each
              connected bank account/credit card.
            </Text>
          ) : (
            <Text>
              Next, we&apos;ll ask you to share monthly bank statements for each
              connected bank account/credit card for all of {currentYear}. These
              are needed for essential accounting procedures.
            </Text>
          )}
        </div>

        <div className="space-y-6">
          <Accordion type="single" collapsible variant="text">
            <Accordion.Item value="why-no-auto-access">
              <Accordion.Trigger>
                Why do I need to do this even though I connected my bank
                account?
              </Accordion.Trigger>
              <Accordion.Content>
                <Text>
                  Connecting your account doesn&apos;t automatically grant Heard
                  access to your bank statements. Common reasons we may not have
                  access:
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>
                      Your bank doesn&apos;t allow Heard access to your
                      statements
                    </li>
                    <li>
                      You declined access to your statements when connecting
                      your account
                    </li>
                  </ul>
                </Text>
              </Accordion.Content>
            </Accordion.Item>

            <Accordion.Item value="why-statements-needed">
              <Accordion.Trigger>
                Why does Heard need monthly statements?
              </Accordion.Trigger>
              <Accordion.Content>
                <Text>
                  We need your bank statements to get your books set up and
                  reconciled. In the future, we&apos;ll reconcile automatically
                  when possible and will only need bank statements if
                  there&apos;s a Plaid connection error.
                </Text>
              </Accordion.Content>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  )
}
